import * as ActionTypes from '@/store/mutations/menu/type'

export default {
  // 注销
  menuChange: ({ commit }, params) => {
    commit(ActionTypes.MENU_CHANGE, params)
  },
  // MENU_INIT
  menuInit: ({ commit }, params) => {
    commit(ActionTypes.MENU_INIT, params)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/menu/menu.js